import {BaseContainerModel} from '../base-container.model';
import {app_perm_template_hdr_RowClass, app_perm_template_line_RowInterface } from '../../dbschema';

export class PermissionTemplateContainerModel extends BaseContainerModel {
  app_perm_template_hdr: app_perm_template_hdr_RowClass = new app_perm_template_hdr_RowClass();
  app_perm_template_lines: Array<app_perm_template_line_RowInterface> = [];
}
